<template>
  <v-app light id="app">
    <template>
      <v-main>
        <div class="dashboard">
          <v-container :fluid="$vuetify.breakpoint.lgAndDown">
            <ActionDashboard v-if="type === 'action'" :actions="actions" :action="action" :plan="plan" :settings="dashboard"></ActionDashboard>
            <MySDGPerformance v-else-if="type === 'my_sdg_performance'" :plan="plan" :actions="actions" :settings="dashboard"></MySDGPerformance>
            <ImpactDashboard v-else-if="type === 'impact'"  :plan="plan" :actions="actions" :settings="dashboard"></ImpactDashboard>
            <SDGDashboard v-else-if="type === 'sdg'" :plan="plan" :actions="actions" :settings="dashboard" :sdg-index="sdgIndex"
                          @sdg-clicked="sdgClicked"></SDGDashboard>
            <OverviewDashboard v-else-if="type === 'overview'" :plan="plan" :actions="actions" :settings="dashboard" :editable="false"></OverviewDashboard>
            <CustomImpactDashboard v-else-if="type === 'custom_impacts'" :plan="plan" :actions="actions"
                                   :root-custom-impact-id="p2"
                                   :settings="dashboard" :custom-impacts="customImpacts" :dashboard-data="dashboardData" :editable="false"></CustomImpactDashboard>
          </v-container>
        </div>

      </v-main>
    </template>

    <v-footer color="transparent" class="px-0 pb-0 align-end" app absolute height="250">
      <v-card color="#e7e7e7" flat tile width="100%">
        <v-card-text>
          <v-row>
            <v-col cols="6" class="text-left">
              <img :src="imageUrl" v-if="tenantId != null" style="max-height: 100px; max-width: 90%;" />
            </v-col>
            <v-col cols="6" class="text-right">
              <img src="/img/SDG_M_icon.png" style="max-height: 150px; max-width: 90%;"/>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
  import publicApi from "../api/public";
  import ActionDashboard from "../components/ActionDashboard/ActionDashboard";
  import MySDGPerformance from "../components/MySDGPerformance/MySDGPerformance";
  import ImpactDashboard from "../components/ImpactDashboard/ImpactDashboard";
  import SDGDashboard from "../components/SDGDashboard/SDGDashboard";
  import OverviewDashboard from "../components/OverviewDashboard/OverviewDashboard";
  import CustomImpactDashboard from "@/components/CustomImpactDashboard/CustomImpactDashboard";
  import CustomImpactService from "@/service/custom_impact.service";

  export default {
    components: { CustomImpactDashboard, OverviewDashboard, SDGDashboard, ImpactDashboard, MySDGPerformance, ActionDashboard },
    name: 'SharingApp',
    data() {
      return {
        tenantId: null,
        dashboardId: null,
        plan: null,
        actions: null,
        dashboard: null,
        dashboardData: null,
        sdgIndex: null,
        customImpacts: null,
      }
    },
    methods: {
      sdgClicked(sdgIndex) {
        this.sdgIndex = sdgIndex;
      },
      async reloadDashboardData() {
        const data = await publicApi.dashboardData(this.tenantId, this.dashboardId);
        this.plan = data.plan;
        this.customImpacts = CustomImpactService.fillLevelAndRoot(data.customImpacts);
        this.actions = data.actions;
        this.dashboardData = { plan: this.plan, actions: this.actions };
        this.dashboard = data.dashboard;

        if (this.p2 != null && this.type === 'sdg') {
          this.sdgIndex = Number.parseInt(this.p2);
        }
      },
    },
    computed: {
      imageUrl() {
        return `${this.$baseUrl}/api/shared/image/${this.tenantId}/logo`
      },
      type() {
        if (this.dashboard == null) {
          return '';
        }
        return this.dashboard.code.split('-')[0];
      },
      p1() {
        return this.dashboard.code.split('-')[1];
      },
      p2() {
        return this.dashboard.code.split('-')[2];
      },
      action() {
        if (this.type === 'action') {
          return this.actions.find(f => f.id === Number.parseInt(this.p2));
        }
        return null;
      },
    },
    mounted() {
      const uri = window.location.search.substring(1);
      const params = new URLSearchParams(uri);
      const dashboardId = params.get("d");
      const tenantId = params.get("t");

      this.tenantId = tenantId;
      this.dashboardId = dashboardId;

      this.reloadDashboardData();
    }
  }
</script>

<style lang="scss">
  @import "../sass/commonstyles.scss";
</style>
